import * as Illustration from "@npco/zeller-design-system/illustration";
import type { ADT } from "pb.adt";

import * as transport from "../../../transport";
import { Layout } from "../shared/layout";
import { NetworkErrorPrompt } from "../shared/network-error-prompt";
import { Prompt } from "../shared/prompt";
import type { Page } from "../terminal-setup";

export function PageError({
	page,
	onLogout,
	pending,
}: {
	page?: ADT.Pick<Page, "Error">;
} & Required<Pick<Layout.Props, "onLogout" | "pending">>) {
	if (page?.type === "network") {
		return (
			<Layout
				actionsStyle="full-width"
				logo
				onClose={() => void transport.Resolve.Error("Network Failure")}
				pending={pending}
				actions={
					page?.onRetry && [{ label: "Try Again", onClick: page.onRetry }]
				}
			>
				<NetworkErrorPrompt />
			</Layout>
		);
	}

	const { title, message, onClose } = getErrorMessages(page?.type);

	return (
		<Layout logo onClose={onClose} onLogout={onLogout} pending={pending}>
			<Prompt
				image={<Illustration.ErrorBalance />}
				title={title}
				message={message}
				action={page?.onRetry && { label: "Try Again", onClick: page.onRetry }}
			/>
		</Layout>
	);
}

function getErrorMessages(type: ADT.Pick<Page, "Error">["type"]): {
	title: string;
	message: string;
	onClose: () => void;
} {
	if (type === "request") {
		return {
			title: "Protocol failure.",
			message: "Please ensure you're using a compatible SDK version.",
			onClose: () => void transport.Resolve.Error("Operation Request Invalid"),
		};
	} else if (type === "no-entities") {
		return {
			title: "No business found.",
			message:
				"Your account isn't linked to a business. Please contact support to get set up.",
			onClose: () => void transport.Resolve.Error("Setup Required"),
		};
	} else {
		return {
			title: "Something went wrong.",
			message: "Please try again, or contact support if problem persists.",
			onClose: () => void transport.Resolve.Error("Operation Failure"),
		};
	}
}
